/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import EditBudgetName from "../components/Modals/EditBudgetName";
import { BudgetBucketNodeItem, TransactionAllocation, BudgetItem, BudgetType, BudgetVariant, CurrentUser, DateTime, FamilyBucketPluralLabel, FamilyHasAccess, ReceiptEmailItem, TimeframeItem, TransactionItem, USCurrency, UserItem } from "../types";
import { useItems } from "../features/Fetch/Items";
import { Button, Grid } from "@mui/material";
import { ModalProps, setProps } from "../features/Slices/modalSlice";
import { useNavigate } from "react-router-dom";
import BudgetReport from "../components/Modals/BudgetReport";
import { pageLoad } from "../App";
import { Features } from "../constants";
import moment, { Moment } from "moment";
import Divider from "../components/Inputs/Divider";
import Transaction from "../components/ListItems/Transaction";
import EditTransaction from "../components/Modals/EditTransaction";
import { ChevronLeft, ChevronRight, PencilSquare } from "react-bootstrap-icons";
import EditBudgetColor from "../components/Modals/EditBudgetColor";
import EditBudgetBucketNodes from "../components/Modals/EditBudgetBucketNodes";
import EditBudgetPeriod from "../components/Modals/EditBudgetPeriod";
import EditBudgetTimeframe from "../components/Modals/EditBudgetTimeframe";
import EditBudget from "../components/Modals/EditBudget";
import EditBudgetPeriodEnd from "../components/Modals/EditBudgetPeriodEnd";
import EditBudgetUsers from "../components/Modals/EditBudgetUsers";
import EditBudgetOther from "../components/Modals/EditBudgetOther";
import { setUseModalSpace } from "../features/Slices/modalSpaceSlice";

const BudgetTransactions = (props: any) => {
	const repo = useItems();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const routeInfo = location.pathname.toLowerCase().split('/');
	const budgetId = parseInt(routeInfo[2]);
	const routeDate = moment(routeInfo[3], 'YYYY-MM-DD', true);
	if (isNaN(budgetId) || budgetId < 1 || routeInfo.length < 4 || !routeDate.isValid()) {
		navigate('/budgets');
	}

	const user: CurrentUser = useSelector((state: any) => state.userData.value);
	useEffect(() => {
		if (pageLoad.instance === 2 && user.token && user.isActive) return;
		UpdateDate(routeDate);
	}, []);
	
	useEffect(() => {
		dispatch(setUseModalSpace(false));
		return () => { dispatch(setUseModalSpace(true)); };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch]);

	const [currentDate, setCurrentDate] = useState(new DateTime());
	let curDate: DateTime = new DateTime();

	const modal: ModalProps = useSelector((state: any) => state.modal.value);
	const isMobile: boolean = useSelector((state: any) => state.isMobile.value);

	let transactions = repo.SortedTransactions(null) ?? undefined;
	const checkRequests: TransactionItem[] = useSelector((state: any) => state.checkRequests.value);
	const timeframes: TimeframeItem[] = useSelector((state: any) => state.timeframes.value);
	const users: UserItem[] = useSelector((state: any) => state.users.value);
	let budgets: BudgetItem[] = useSelector((state: any) => state.budgets.value);
	const budgetTree = repo.GetBudgetTree();
	const receiptEmails: ReceiptEmailItem[] = useSelector((state: any) => state.receiptEmails.value);
	const showHoh = user.isHoH && !isMobile;

	if (!FamilyHasAccess(user, Features.Budgets)) {
		navigate("/");
		return <></>;
	}

	const hasExternal = (transactions?.filter(t => t.isExternal)?.length ?? 0) > 0;

	const budget = budgets.find(b => b.budgetId === budgetId);
	if (budget) {
		transactions = transactions?.filter(t => t.transactionDate >= budget!.variant.startDate && t.transactionDate < budget!.endDate! && t.allocations.map(c => c.budgetId).includes(budgetId));
	} else {
		transactions = [] as TransactionItem[];
	}

	const usrString = users?.filter((c: UserItem) => budget?.userIds.includes(c.userAccountId))!.map((c: UserItem) => `${c.firstName} ${c.lastName}`).join(", ");

	const atf = budget?.activeTimeframes.find(t => (!t.startDate || t.startDate! <= curDate) && (!t.endDate || t.endDate! >= curDate));

	const isIncomeBudget = budget?.budgetType === BudgetType.Income;
	const isCombinedBudget = budget?.budgetType === BudgetType.Combined;
	const incomeTotal = budget?.variant?.incomeAmount ?? 0;
	const incomeSpent = budget?.incomeAmountGained ?? 0;
	const incomeRemaining = budget?.incomeAmountRemaining ?? 0;
	const mainTotal = isIncomeBudget ? incomeTotal : budget?.variant?.amount ?? 0;
	const mainSpent = isIncomeBudget ? incomeSpent : budget?.amountSpent ?? 0;
	const mainRemaining = isIncomeBudget ? incomeRemaining : budget?.amountRemaining ?? 0;

	const activeDate = currentDate.startOfDay();
	const bucketDefinitionSortOrder = new Map(
		(user.bucketDefinitions?.definitions ?? []).map((definition, index) => [
			definition.bucketTypeKey.toLowerCase(),
			definition.sortOrder ?? index,
		] as const)
	);
	const activeBudgetBucketGroups = Object.values(
		(budget?.bucketNodes ?? [])
			.filter(bucketNode => IsActiveTimeframe(bucketNode, activeDate))
			.reduce((result, bucketNode) => {
				const key = bucketNode.bucketTypeKey.toLowerCase();
				if (!result[key]) {
					result[key] = {
						bucketTypeKey: bucketNode.bucketTypeKey,
						items: [] as BudgetBucketNodeItem[]
					};
				}
				result[key].items.push(bucketNode);
				return result;
			}, (user.bucketDefinitions?.definitions ?? [])
				.filter(definition => definition.isEnabled && definition.requiresBudgetMapping)
				.reduce((result, definition) => {
					const key = definition.bucketTypeKey.toLowerCase();
					if (!result[key]) {
						result[key] = {
							bucketTypeKey: definition.bucketTypeKey,
							items: [] as BudgetBucketNodeItem[]
						};
					}
					return result;
				}, {} as Record<string, { bucketTypeKey: string, items: BudgetBucketNodeItem[] }>)))
		.map(group => ({
			bucketTypeKey: group.bucketTypeKey,
			label: FamilyBucketPluralLabel(user, group.bucketTypeKey, group.bucketTypeKey),
			items: [...group.items].sort((a, b) => a.displayName.localeCompare(b.displayName))
		}))
		.sort((a, b) => {
			const first = bucketDefinitionSortOrder.get(a.bucketTypeKey.toLowerCase()) ?? Number.MAX_SAFE_INTEGER;
			const second = bucketDefinitionSortOrder.get(b.bucketTypeKey.toLowerCase()) ?? Number.MAX_SAFE_INTEGER;
			return first - second || a.label.localeCompare(b.label);
		});

	return (
		<Grid container spacing={2} justifyContent="center" className='p-3'>
			<Grid item xs={12} md={6}>
			<Grid container columnSpacing={2} justifyContent="center" className='p-3' style={{ color: budget?.color }}>
				<Grid item xs={12}>
					<h2 className="mt-2 mb-0">
					{showHoh && <>
							<h6 className="d-inline-block text-app px-3 cursor-pointer" onClick={() => OpenBudgetModal('name')}>
								<PencilSquare className='mb-1 mx-1' />
							</h6>
						</>}
						{budget?.description}
					</h2>
				</Grid>
				{budget && <>
					<Grid item xs={12} className='mb-0'>
						<Divider />
						{activeBudgetBucketGroups.length === 0 && (
							<span className="text-app">No linked items for this period.</span>
						)}
						{activeBudgetBucketGroups.map(group => (
							<div className="mb-1" key={group.bucketTypeKey}>
								<b>{group.label}:</b><br />
								{showHoh && <>
									<h6 className="d-inline-block text-app px-3 cursor-pointer" onClick={() => OpenBudgetModal('nodes', group.bucketTypeKey)}>
										<PencilSquare className='mb-1 mx-1' />
									</h6>
								</>}
								{group.items.length > 0
									? group.items.map(bucketNode => bucketNode.displayName).join(", ")
									: <span className="text-app">None</span>}
							</div>
						))}
					</Grid>
					<Grid item xs={12} className='mb-0'>
						<Divider />
						<b>Users:</b><br />
						{showHoh && <>
							<h6 className="d-inline-block text-app px-3 cursor-pointer" onClick={() => OpenBudgetModal('user')}>
								<PencilSquare className='mb-1 mx-1' />
							</h6>
						</>}
						{usrString}
					</Grid>
					<Grid item xs={12} className='mb-5'>
						<Divider />
						<b>Active Timeframes:</b><br />
						{showHoh && <>
							<h6 className="d-inline-block text-app px-3 cursor-pointer" onClick={() => OpenBudgetModal('time')}>
								<PencilSquare className='mb-1 mx-1' />
							</h6>
						</>}
						{atf && (<>
						<b>{`Active from ${atf!.startDate}${atf!.endDate == null ? "" : ` to ${atf!.endDate}`}:`}</b>{` Budget Resets ${timeframes.find(t => t.timeframeId === atf!.id)?.longDescription}`}
						</>)}
						<Divider />
					</Grid>
					<Grid item xs={4} className='mb-3 text-app centered small'>
						{budget.activeTimeframes.filter(t => t.startDate && budget && t.startDate < budget.variant.startDate).length > 0 &&
							<ChevronLeft className="h3" onClick={BackDate} />
						}
					</Grid>
					<Grid item xs={4} className='mb-3 text-app centered small'>
						{((budget!.variant.timeframeId ?? budget!.timeframeId) === -3 && !budget!.variant.endDate) && <>Starting </>}
						{budget!.variant.startDate.toString()}
						{((budget!.variant.timeframeId ?? budget!.timeframeId) !== -3 || budget!.variant.endDate) && <> to {budget!.endDate!.addDays(-1).toString()}</>}
					</Grid>
					<Grid item xs={4} className='mb-3 text-app centered small'>
						{budget.activeTimeframes.filter(t => (!t.endDate && t.id !== -3) || (t.endDate && t.endDate > currentDate)).length > 0 &&
							<ChevronRight className="h3" onClick={ForwardDate} />
						}
					</Grid>
					<Grid item xs={12} className="px-5 text-success">
						{showHoh && <>
							<h6 className="d-inline-block text-app px-3 cursor-pointer" onClick={() => OpenBudgetModal('per')}>
								<PencilSquare className='mb-1 mx-1' />
							</h6>
						</>}
						{USCurrency(mainSpent)}
						{(mainTotal > 0) && <> of {USCurrency(mainTotal).substring(1)}</>}
					</Grid>
					<Grid item xs={12} className={`mb-3 px-5 ${mainRemaining > 0 ? 'text-app' : 'text-danger'}`}>
						{(mainTotal > 0) && <>{USCurrency(Math.abs(mainRemaining))} {mainRemaining >= 0 ? "left" : "over"}</>}
					</Grid>
					{isCombinedBudget && (
						<>
							<Grid item xs={12} className="px-5 text-success">
								{USCurrency(incomeSpent)}
								{(incomeTotal > 0) && <> of {USCurrency(incomeTotal).substring(1)} income</>}
							</Grid>
							<Grid item xs={12} className={`mb-3 px-5 ${incomeRemaining > 0 ? 'text-app' : 'text-danger'}`}>
								{(incomeTotal > 0) && <>{USCurrency(Math.abs(incomeRemaining))} {incomeRemaining >= 0 ? "left" : "over"}</>}
							</Grid>
						</>
					)}
					{budget?.subBudgets && budget.subBudgets.length > 0 && (
						<Grid item xs={12} className="mb-3 px-5">
							<b>Sub Budgets:</b>
							{budget.subBudgets.map((sub, i) => (
								(() => {
									const subIncomeTotal = sub.variant?.incomeAmount ?? 0;
									const subIncomeSpent = sub.incomeAmountGained ?? 0;
									const subIncomeRemaining = sub.incomeAmountRemaining ?? 0;
									const subMainTotal = isIncomeBudget ? subIncomeTotal : sub.variant?.amount ?? 0;
									const subMainSpent = isIncomeBudget ? subIncomeSpent : sub.amountSpent ?? 0;
									const subMainRemaining = isIncomeBudget ? subIncomeRemaining : sub.amountRemaining ?? 0;
									return (
							<Grid container spacing={1} key={i} style={{ marginBottom: 4 }}>
								<Grid item xs={12} lg={4}>
									{sub.description || `SubBudget ${i + 1}`}
								</Grid>
								<Grid item xs={6} lg={4} className="text-success">
									{USCurrency(subMainSpent)}
									{(subMainTotal > 0) && <> of {USCurrency(subMainTotal).substring(1)}</>}
								</Grid>
								<Grid item xs={6} lg={4} className={`mb-3 ${subMainRemaining > 0 ? 'text-app' : 'text-danger'}`}>
									{(subMainTotal > 0) && <>{USCurrency(Math.abs(subMainRemaining))} {subMainRemaining >= 0 ? "left" : "over"}</>}
								</Grid>
								{isCombinedBudget && (
									<>
										<Grid item xs={6} lg={4} className="text-success">
											{USCurrency(subIncomeSpent)}
											{(subIncomeTotal > 0) && <> of {USCurrency(subIncomeTotal).substring(1)} income</>}
										</Grid>
										<Grid item xs={6} lg={4} className={`mb-3 ${subIncomeRemaining > 0 ? 'text-app' : 'text-danger'}`}>
											{(subIncomeTotal > 0) && <>{USCurrency(Math.abs(subIncomeRemaining))} {subIncomeRemaining >= 0 ? "left" : "over"}</>}
										</Grid>
									</>
								)}
							</Grid>
								);
							})()
							))}
						</Grid>
					)}
					<Grid item xs={6}>
						<Button fullWidth variant="contained" onClick={OpenModal} className="bg-app text-white">View Report</Button>
					</Grid>
				</>}
			</Grid>
			</Grid>
			<Grid item xs={12} md={6} className="left-transaction-panel">
			<Grid container rowSpacing={3} justifyContent="center" className="mt-1">
				<Grid item xs={12} className='centered mb-2'>
					<h3 className="mt-2 text-app">Transactions</h3>
				</Grid>
				{transactions != null && (
					<>
						{transactions.length > 0 && (
							<Grid container>
								<>
									{
										transactions.map(transaction => {
											return (
												<div className="w-100" key={`transactdiv${transaction.accountTransactionId}`}>
													{!IsCurrentDate(transaction) && (
														<Divider
															Text={curDate.toString()}
															key={`date${transaction.accountTransactionId}`} />
													)}
													<Transaction
														Item={transaction}
														Color={transaction.color}
														HasExternal={hasExternal}
														OnClick={() => OpenTransactionModal(transaction.accountTransactionId)}
														key={`transaction${transaction.accountTransactionId}`} />
												</div>
											);
										})
									}
								</>
							</Grid>
						)}
					</>
				)}
			</Grid>
			</Grid>
		</Grid>
	);

	function HideModal() {
		dispatch(setProps({ ...modal, IsOpen: false }));
	}

	function BackDate() {
		let start = budget!.variant.startDate.addDays(-1);
		navigate(`/budget/${budgetId}/${start.toQueryString()}`, { replace: true });
		repo.GetBudgetsWithDateAsync(start);
		setCurrentDate(start);
	}

	async function ForwardDate() {
		let end = budget!.endDate!;
		budgets = await repo.GetBudgetsWithDateAsync(end);

		let newBudgetId = parseInt(routeInfo[2]);
		let newBudget = budgets.find(b => b.budgetId === newBudgetId);
		if (newBudget?.variant.timeframeId !== -3) {
			end = newBudget!.endDate!.addDays(-1);
		} else {
			let possibleDates = transactions!.map(t => t.transactionDate.Value.getTime());
			possibleDates.push(curDate.Value.getTime());
			end = new DateTime(new Date(Math.max.apply(null, possibleDates)));
		}

	navigate(`/budget/${newBudgetId}/${end.toQueryString()}`, { replace: true });
		if (Math.abs(end.dayDiff(new DateTime(routeDate))) > 0) {
			repo.GetBudgetsWithDateAsync(end);
			setCurrentDate(end);
		}
	}

	//Budgets
	function SaveBudget(item: BudgetItem) {
		if (!user.isHoH) return;
		let variant = { ...item.variant };
		HideModal();
		repo.UpdateBudgetAsync(item, variant, item.budgetId === 0, false)
			.then(() => repo.GetBudgetsWithDateAsync(currentDate));
	}
	function SaveBudgetName(item: BudgetItem) {
		if (!user.isHoH) return;
		HideModal();
		repo.UpdateBudgetNameAsync(item)
			.then(() => repo.GetBudgetsWithDateAsync(currentDate));
	}
	function SaveBudgetColor(item: BudgetItem) {
		if (!user.isHoH) return;
		HideModal();
		repo.UpdateBudgetColorAsync(item)
			.then(() => repo.GetBudgetsWithDateAsync(currentDate));
	}
	function SaveBudgetNodes(item: BudgetItem) {
		if (!user.isHoH) return;
		HideModal();
		repo.UpdateBudgetNodesAsync(item)
			.then(() => repo.GetBudgetsWithDateAsync(currentDate));
	}
	function SaveBudgetGoal(item: BudgetItem) {
		if (!user.isHoH) return;
		HideModal();
		let variant = { ...item.variant };
		repo.UpdateBudgetGoalAsync(item, variant)
			.then(() => repo.GetBudgetsWithDateAsync(currentDate));
	}
	function SaveBudgetEndDate(item: BudgetItem) {
		if (!user.isHoH) return;
		HideModal();
		let variant = { ...item.variant };
		repo.UpdateBudgetEndDateAsync(item, variant)
			.then(() => repo.GetBudgetsWithDateAsync(currentDate));
	}
	function DeleteBudget(item: BudgetItem) {
		if (!user.isHoH) return;
		repo.UpdateBudgetAsync(item, item.variant, false, true);
		HideModal();
		navigate('/budgets');
	}

	function OpenModal() {
		if (budget) {
			let modalBudget = {
				budgetId: budget.budgetId,
				description: budget.description,
				color: budget.color,
				timeframeId: budget.timeframeId,
				variant:
					{
						budgetVariantId: budget.variant.budgetVariantId,
						budgetId: budget.variant.budgetId,
						amount: budget.variant.amount,
						incomeAmount: budget.variant.incomeAmount,
						startDate: budget.variant.startDate,
						isDefault: budget.variant.isDefault,
						endDate: budget.variant.endDate
					} as BudgetVariant,
				userIds: budget.userIds,
				isMine: budget.isMine,
				budgetType: budget.budgetType,
				requiresApproval: budget.requiresApproval,
				amountSpent: budget.amountSpent,
				amountRemaining: budget.amountRemaining,
				incomeAmountGained: budget.incomeAmountGained,
				incomeAmountRemaining: budget.incomeAmountRemaining
			} as BudgetItem;
			const newModal = {
				...modal,
				Body: <BudgetReport Budget={modalBudget} Transactions={transactions} CheckRequests={checkRequests} StartDate={modalBudget.variant.startDate} EndDate={new DateTime()} User={user} OpenBudget={() => OpenBudgetModal("")} Close={HideModal} ViewReport={ViewReport} />,
				IsOpen: true,
				WasOpen: false
			}
			dispatch(setProps(newModal));
		}
	}

	function OpenBudgetModal(property: string, bucketTypeKey?: string) {
		if (budget) {
			const modalBudget = {
				budgetId: budget.budgetId,
				description: budget.description,
				color: budget.color,
				activeTimeframes: budget.activeTimeframes,
				bucketNodes: budget.bucketNodes,
				endDate: budget.endDate,
				timeframeId: budget.timeframeId,
				variant:
					{
						budgetVariantId: budget.variant.budgetVariantId,
						budgetId: budget.variant.budgetId,
						amount: budget.variant.amount,
						incomeAmount: budget.variant.incomeAmount,
						startDate: budget.variant.startDate,
						isDefault: budget.variant.isDefault,
						endDate: budget.variant.endDate,
						defaultEndDate: budget.variant.defaultEndDate,
						timeframe: budget.variant.timeframe,
						timeframeId: budget.variant.timeframeId
					} as BudgetVariant,
				userIds: budget.userIds,
				isMine: budget.isMine,
				isViewTransactions: budget.isViewTransactions,
				budgetType: budget.budgetType,
				requiresApproval: budget.requiresApproval,
				amountSpent: budget.amountSpent,
				amountRemaining: budget.amountRemaining,
				incomeAmountGained: budget.incomeAmountGained,
				incomeAmountRemaining: budget.incomeAmountRemaining,
				subBudgets: budget.subBudgets
			} as BudgetItem;

			let item: JSX.Element = <EditBudget Item={modalBudget} Timeframes={timeframes} OnSave={SaveBudget} Close={HideModal} />;
			switch (property) {
				case "name":
					item = <EditBudgetName Item={modalBudget} Timeframes={timeframes} OnSave={SaveBudgetName} Close={HideModal} />;
					break;
				case "color":
					item = <EditBudgetColor Item={modalBudget} Timeframes={timeframes} OnSave={SaveBudgetColor} Close={HideModal} />;
					break;
				case "nodes":
						if (!bucketTypeKey) return;
						item = <EditBudgetBucketNodes Item={modalBudget} BucketTypeKey={bucketTypeKey} OnSave={SaveBudgetNodes} Close={HideModal} />;
					break;
				case "per":
					item = <EditBudgetPeriod Item={modalBudget} Timeframes={timeframes} OnSave={SaveBudgetGoal} Close={HideModal} />;
					break;
				case "pend":
					item = <EditBudgetPeriodEnd Item={modalBudget} Timeframes={timeframes} OnSave={SaveBudgetEndDate} Close={HideModal} />;
					break;
				case "time":
					item = <EditBudgetTimeframe Item={modalBudget} Timeframes={timeframes} OnDelete={DeleteBudget} Close={HideModal} User={user} CurrentDate={currentDate} />;
					break;
				case "user":
					item = <EditBudgetUsers Item={modalBudget} Timeframes={timeframes} OnSave={SaveBudgetNodes} Close={HideModal} />;
					break;
				case "oth":
					item = <EditBudgetOther Item={modalBudget} Timeframes={timeframes} OnSave={SaveBudgetNodes} Close={HideModal} />;
					break;
			}

			const newModal = {
				...modal,
				Body: item,
				IsOpen: true,
				WasOpen: false
			}
			dispatch(setProps(newModal));
		}
	}

	function ViewReport() {
		HideModal();
		navigate("/report/budgets");
	}

	//Transactions
	async function SaveTransaction(item: TransactionItem) {
		HideModal();
		let bcas = [] as TransactionAllocation[];
		for (let i = 0; i < item.allocations.length; i++) {
			let amount = { ...item.allocations[i] };
			if (item.miles && item.miles > 0) {
				amount.amount = item.miles * (item.rate ?? 0);
			}
			bcas = [...bcas, amount]
		}
		item = {
			...item,
			allocations: bcas
		};
		if (item.receiptEmailIds && item.receiptEmailIds.length > 0) {
			item.receiptEmailIds.forEach(id => {
				repo.UpdateReceiptEmailAsync(receiptEmails.find(r => r.receiptEmailId === id)!, false, true);
			})
		}
		if (item.importedTransactionId) {
			repo.UpdateTransactionAsync(transactions!.find(r => r.accountTransactionId === item.importedTransactionId)!, false, true);
		}
		await repo.UpdateTransactionAsync(item, item.accountTransactionId === 0, false);
		repo.GetBudgetsAsync();
		repo.GetBucketNodesAsync();
	}

	function DeleteTransaction(item: TransactionItem) {
		repo.UpdateTransactionAsync(item, false, true);
		HideModal();
	}

	function OpenTransactionModal(idx: number) {
		let transaction = transactions!.find(t => t.accountTransactionId === idx);
		if (transaction) {
			const newModal = {
				...modal,
				Body: <EditTransaction Mileage={transaction.miles != null} ReceiptEmails={receiptEmails} Transaction={transaction} Budgets={budgetTree} Transactions={transactions?.filter(t => !t.isExternal)} OnSave={SaveTransaction} OnDelete={DeleteTransaction} Close={HideModal} />,
				IsOpen: true,
				WasOpen: false
			}
			dispatch(setProps(newModal));
		}
	}

	async function UpdateDate(newValue: Moment) {
		let end = new DateTime(newValue);
		const newBudgets: BudgetItem[] = await repo.GetBudgetsWithDateAsync(end);

		let newBudgetId = parseInt(routeInfo[2]);
		let newBudget = newBudgets.find(b => b.budgetId === newBudgetId);
		if ((newBudget?.variant.timeframeId ?? newBudget?.timeframeId) !== -3 || newBudget?.variant.endDate != null) {
			end = newBudget!.endDate!.addDays(-1);
		}
		else {
			let possibleDates = transactions!.map(t => t.transactionDate.Value.getTime());
			possibleDates.push(curDate.Value.getTime());
			end = new DateTime(new Date(Math.max.apply(null, possibleDates)));
		}

		if (Math.abs(end.dayDiff(new DateTime(routeDate))) > 0) {
			navigate(`/budget/${budgetId}/${end.toQueryString()}`, { replace: true });
			repo.GetBudgetsWithDateAsync(end);
			setCurrentDate(end);
		}
	}

	function IsCurrentDate(transaction: TransactionItem) {
		if (curDate.Value.getTime() !== new DateTime(transaction.transactionDate.Value).startOfDay().Value.getTime()) {
			curDate = new DateTime(transaction.transactionDate.Value).startOfDay();
			return false;
		}
		return true;
	}

	function IsActiveTimeframe(timeframe: { startDate?: DateTime | null, endDate?: DateTime | null }, date: DateTime) {
		const start = timeframe.startDate ?? null;
		const end = timeframe.endDate ?? null;
		if (start && date < start.startOfDay()) return false;
		if (end && date > end.startOfDay()) return false;
		return true;
	}
}

export default BudgetTransactions;